if ($('.contact-us').length > 0) {
    document.addEventListener(
        'input',
        function(event) {
            // Only run on our select menu
            if (event.target.id !== 'dropdown-1') return;

            let item = event.target.options[
                event.target.selectedIndex
            ].getAttribute('data-dropdown');

            let subdropdown = $('#dropdown-' + item);
            $('.sub-dropdown').hide();
            subdropdown.show();
            subdropdown.focus();

            if (item == 4) {
                $(
                    '.desktop-full-width, .desktop-half-width, .to-hide, .contact-us-brazil__radio-box-holder, .contact-us-brazil__item-holder'
                ).hide();
            } else {
                $(
                    '.desktop-full-width, .desktop-half-width, .to-hide, .contact-us-brazil__radio-box-holder, .contact-us-brazil__item-holder'
                ).show();
            }
        },
        false
    );
}
